<ridango-navigation-bar>
    <ul role="menu">
        <li *ngIf="profileParentPageActions.includes('related-cards')" role="menuitem">
            <a
                [routerLink]="'/account/related-cards' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                aria-current="page"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_CARDS_ACTIVE_TICKETS' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('cards')" role="menuitem">
            <a
                [routerLink]="'/account/cards' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                aria-current="page"
                routerLinkActive="active">
                {{ 'APP_MENU_CARD' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('tickets')" role="menuitem">
            <a
                [routerLink]="'/account/tickets' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                aria-current="page"
                routerLinkActive="active">
                {{ 'HEADER_TICKETS' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('purchase-history')" role="menuitem">
            <a
                [routerLink]="'/account/purchase-history' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_PURCHASE_HISTORY' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('validation-history')" role="menuitem">
            <a
                [routerLink]="'/account/validation-history' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_VALIDATION_HISTORY' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('company-users')" role="menuitem">
            <a
                [routerLink]="'/account/company-users' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'POWER_USERS' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('switch-company')" role="menuitem">
            <a
                [routerLink]="'/account/switch-company' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'SWITCH_COMPANY' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('seutulippu')" role="menuitem">
            <a
                [routerLink]="'/account/seutulippu' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_SEUTULIPPU' | translate }}
            </a>
        </li>

        <li
            *ngIf="env.ONDEMAND?.SHOW_LINKS && profileParentPageActions.includes('bookings') && showBookARide"
            role="menuitem">
            <a
                [routerLink]="'/account/bookings' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_BOOKINGS' | translate }}
            </a>
        </li>
        <li
            *ngIf="env.ONDEMAND?.SHOW_LINKS && profileParentPageActions.includes('ride-history') && showBookARide"
            role="menuitem">
            <a
                [routerLink]="'/account/ride-history' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_RIDE_HISTORY' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('company-profile')" role="menuitem">
            <a
                [routerLink]="(isDepartment ? '/account/edit-department' : '/account/company-profile') | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ isDepartment ? ('DEPARTMENT_PROFILE' | translate) : ('COMPANY_PROFILE' | translate) }}
            </a>
        </li>

        <li
            *ngIf="
                (env.NOTIFICATION_CHANNELS &&
                    env.NOTIFICATION_CHANNELS.length > 0 &&
                    profileParentPageActions.includes('notification-settings')) ||
                (env.ACCOUNT?.SHOW_NEW_NOTIFICATION_SETTINGS &&
                    profileParentPageActions.includes('notification-settings'))
            "
            role="menuitem">
            <a
                [routerLink]="'/account/notification-settings' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_NOTIFICATION_SETTINGS' | translate }}
            </a>
        </li>

        <li *ngIf="profileParentPageActions.includes('account-profile')" role="menuitem">
            <a
                [routerLink]="'/account/profile' | localize"
                [routerLinkActiveOptions]="{ exact: false }"
                routerLinkActive="active">
                {{ 'MY_ACCOUNT_PROFILE' | translate }}
            </a>
        </li>
    </ul>
</ridango-navigation-bar>
<router-outlet></router-outlet>
